// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purchase-invoice-dialog .option-label{flex:6}`, "",{"version":3,"sources":["/app/src/components/purchaseOrderSelectField/purchaseOrderSelectField.scss"],"names":[],"mappings":"AAIE,uCACE,MAAA","sourcesContent":["@import 'src/assets/css/_colors.scss';\n\n.purchase-invoice-dialog {\n\n  .option-label {\n    flex: 6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
